import React from "react";
import BetCardBodyDetails from "./BetCardBodyDetails";

export default function BetCardBody() {
	return (
		<React.Fragment>
			<BetCardBodyDetails />
		</React.Fragment>
	);
}
